import * as React from "react";
import { If } from "./if";
import { LoadingSpinner } from "./loading-spinner";

type LoadingSpinnerProps = Parameters<typeof LoadingSpinner>[0]

type Props = { loading: boolean } & LoadingSpinnerProps

/**
 * Renders a loading spinner when the loading value is true.
 */
export function MaybeLoadingSpinner(props: Props): JSX.Element {
    return (
        <If condition={props.loading}>
            <LoadingSpinner {...props} />
        </If>
    )
}
